import { ArrowUpOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
const BackTop = ({ containerRef }) => {
    const handleBackTop = () => {
        console.log('huidin');
        const containerElement = containerRef.current;
        if (containerElement) {
            containerElement.scrollIntoView({
                behavior: 'smooth'
            });
        }
    };
    return (
        <div className={styles.backTop} onClick={handleBackTop}>
            <ArrowUpOutlined className={styles.topIcon} />
        </div>
    );
};
export default BackTop;
